// @flow

export const WAIT = 400;
